import React,{useContext, useState, useEffect} from 'react'
import InputBar from '../minda/InputBar/InputBar'
import AddPlanModal from './addPlanModal/AddPlanModal';
import { useSelector } from 'react-redux'
import { AuthInfo, ConfigContext } from "../../../../App";
import { isIsoDate, jsonToURL } from "../../../../utils";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faPlus } from "@fortawesome/free-solid-svg-icons";
import DataTablePlugin from './DataTablePlugin';
import axios from 'axios';


export const ProductionPlanning = () => {

    const {companyId, mmHost } = useContext(ConfigContext);
    const [productionPlanData, setProductionPlanData] = useState([]);
    const [loading, setloading] = useState(false);
    const [fetchStatus, setFetchStatus] = useState(true); 
    const [search, setSearch] = useState()
    const [searchedData, setSearchedData] = useState([])
    const [openAddNewModel, setOpenAddNewModel] = useState(false);

    let plantId = useSelector((state) => state.saveSelectedPlant);
    if(plantId.plan){
        plantId = plantId.plan.selectedOption.value;
    }else {
        plantId = "";
    }
    
    let lineId = useSelector((state) => state.saveSelectedLine);
  if (lineId.plan) {
    lineId = lineId.plan.selectedOption.value;
  } else {
    lineId = "";
  }

  let timings = useSelector((state) => state.timings);
  timings = timings.plan;
  let startDate = 1;
  let endDate = 1;
  if (timings) {
    const sDateAndTime = timings.startTime.toLocaleString("sv-SE")
    const correctedStartDate = sDateAndTime.slice(0,10);
    const correctedStartTime = sDateAndTime.slice(11,19)
    startDate = `${correctedStartDate}T${correctedStartTime}.000Z`
    const eDateAndTime = timings.endTime.toLocaleString("sv-SE")
    const correctedEndDate = eDateAndTime.slice(0,10);
    const correctedEndTime = eDateAndTime.slice(11,19)
    endDate = `${correctedEndDate}T${correctedEndTime}.000Z`
  }
    
  let queryParams = {
    startDate,
    endDate,
    plantId,
    lineId,
  }; 

  const updateData = async () => {
    // if (!isIsoDate(queryParams.startTime) || !isIsoDate(queryParams.endTime)) {
    //   throw "INVALID TIME FORMAT";
    //   return;
    // }

    let planURL = `${mmHost}/pplan?${jsonToURL(
      queryParams
    )}`;

    setloading(true);
    axios
      .get(planURL)
      .then(function (data) {
       setProductionPlanData(data.data);
       setSearchedData(data.data)
        setloading(false);

        // toast.info("LeaderBoard Loaded", {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        return;
      })
      .catch((e) => {
        setloading(false);
        // toast.error("LeaderBoard couldn't load", {
        //   position: toast.POSITION.TOP_RIGHT,
        // });
        console.log("you are just stuck in axios request", e);
        return;
      });
  };

  useEffect(() => {
    updateData();
  }, [fetchStatus]);

  useEffect(() => {
    setTimeout(() => {
      setFetchStatus(!fetchStatus);
    }, 500);
  }, []);


useEffect(() => {
  const searchResult = productionPlanData.filter((recievedData) => { 
      return (String(recievedData.toolId).toLowerCase().includes(search.toLowerCase())) ||
             String(recievedData.planningId).toLowerCase().includes(search.toLowerCase()) ||
             recievedData.quantityPlanned.toString().includes(search.toLowerCase()) ||
             (String(recievedData.machineId).toLowerCase().includes(search.toLowerCase())) ||
              recievedData.startDate.toLowerCase().includes(search.toLowerCase()) ||
              recievedData.endDate.toLowerCase().includes(search.toLowerCase())        
    }); 
    setSearchedData(searchResult)
 },[search])


  return (
    <>
    <div>
      <div style={{position: 'relative'}}>
          <InputBar
             setData={setProductionPlanData}
             setFetchStatus={setFetchStatus}
             fetchStatus={fetchStatus}
             loading={loading}
             InsIden={"plan"}
            line={true}
            shift={false}
            shiftDate={false}
            startTime={true}
            endTime={true}
            goback={false}
            defaultOptions={{
              line: [{ value: "", label: "All" }],
              plant: [{ value: "", label: "All" }],
            }}
            startTimeDisabled={false}
            endTimeDisabled={false}
            startTimeMannual={true}
            endTimeMannual={true}
            ></InputBar>
          </div>
          <div style={{ float: "right"}} >
          <button onClick={()=> setOpenAddNewModel(true)} className="btn btn-primary">
          <FontAwesomeIcon
          type="button"
          icon={faPlus}
        /> Add New</button>    
      </div>
  </div>
    <DataTablePlugin searchedData={searchedData} setSearch={setSearch} search={search}/>
{openAddNewModel && <AddPlanModal CloseAddPlanModel={setOpenAddNewModel} />}
    </>
  )
}
